// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mls-detail-page-container {
  width: 100%;
}
.mls-detail-page-container .content {
  animation: fadeIn 1s;
}
.mls-detail-page-container .content .top-header {
  display: flex;
  gap: 40px;
}
.mls-detail-page-container .content .top-header .hero-banner {
  flex: 2 1;
  width: 100%;
  object-fit: contain;
  max-height: 450px;
}
.mls-detail-page-container .content .top-header .about {
  display: flex;
  width: 100%;
  font-family: "Proxima Nova", sans-serif;
  color: var(--secondary-color-1);
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  row-gap: 24px;
}
.mls-detail-page-container .content .top-header .about .subhero-banner {
  max-height: 150px;
  object-fit: contain;
}
.mls-detail-page-container .content .top-header .about > div {
  width: 100%;
}
.mls-detail-page-container .content .top-header .about .about p {
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  margin: 0;
}
.mls-detail-page-container .content .top-header .about .desc span {
  font-size: 14px;
  font-weight: 400;
  line-height: 35px;
  text-align: justify;
}
.mls-detail-page-container .content .highlights {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
  flex-direction: column;
}
.mls-detail-page-container .content .highlights .top-header {
  color: var(--primary-color-1);
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.mls-detail-page-container .content .highlights .header {
  font-size: 40px;
  color: var(--secondary-color-1);
  font-weight: 700;
  margin: 0;
}
.mls-detail-page-container .content .highlights .highlight {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 20px;
}
.mls-detail-page-container .content .highlights .highlight > div {
  max-width: 320px;
  background-color: #F4F5F6;
  border-radius: 40px;
  padding: 50px;
}
.mls-detail-page-container .content .highlights .highlight > div .number, .mls-detail-page-container .content .highlights .highlight > div .title {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.mls-detail-page-container .content .highlights .highlight > div .number {
  color: var(--primary-color-1);
  margin-bottom: 16px;
}
.mls-detail-page-container .content .highlights .highlight > div .title {
  color: var(--secondary-color-1);
  margin-bottom: 18px;
}
.mls-detail-page-container .content .highlights .highlight > div .desc {
  color: var(--secondary-color-1);
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
}
.mls-detail-page-container .content .market {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  column-gap: 100px;
}
.mls-detail-page-container .content .market > div {
  flex: 1 1;
}
.mls-detail-page-container .content .market .image {
  border-radius: 40px;
  object-fit: contain;
}
.mls-detail-page-container .content .market .details {
  font-family: "Proxima Nova", sans-serif;
}
.mls-detail-page-container .content .market .details .header {
  font-size: 40px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 30px;
  line-height: 50px;
}
.mls-detail-page-container .content .market .details .body {
  font-size: 16px;
  font-weight: 400;
  line-height: 35px;
}
.mls-detail-page-container .content .app-spec {
  display: flex;
  justify-content: center;
}
.mls-detail-page-container .content .team-container {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
  flex-direction: column;
}
.mls-detail-page-container .content .team-container .header {
  font-size: 40px;
  color: var(--secondary-color-1);
  font-weight: 700;
  margin: 0;
}
.mls-detail-page-container .content .team-container .subheader {
  font-size: 16px;
  color: var(--secondary-color-1);
  font-weight: 400;
  text-align: center;
  line-height: 30px;
}
.mls-detail-page-container .content .team-container .team {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.mls-detail-page-container .content .team-container .team .member {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mls-detail-page-container .content .team-container .team .member .member-profile {
  max-width: 200px;
}
.mls-detail-page-container .content .team-container .team .member .member-detail {
  height: 70px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  background-color: var(--secondary-color-1);
}
.mls-detail-page-container .content .team-container .team .member .member-detail p {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: white;
  margin-bottom: 6px;
}
.mls-detail-page-container .content .team-container .team .member .member-detail span {
  font-size: 12px;
  font-weight: 400;
  color: #F4F5F6;
}
.mls-detail-page-container .content .why-invest, .mls-detail-page-container .content .get-intouch {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
  flex-direction: column;
}
.mls-detail-page-container .content .why-invest .header, .mls-detail-page-container .content .get-intouch .header {
  font-size: 32px;
  color: var(--secondary-color-1);
  font-weight: 700;
  line-height: 36px;
}
.mls-detail-page-container .content .why-invest .subheader, .mls-detail-page-container .content .get-intouch .subheader {
  color: #949494;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  max-width: 600px;
  text-align: center;
}
.mls-detail-page-container .content .why-invest .form, .mls-detail-page-container .content .get-intouch .form {
  display: flex;
  animation: fadeIn 0.5s;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .mls-detail-page-container .content .top-header {
    flex-direction: column-reverse;
    align-items: center;
  }
  .mls-detail-page-container .content .top-header .hero-banner {
    max-height: 350px;
  }
  .mls-detail-page-container .content .top-header .about {
    display: flex;
    width: 100%;
    font-family: "Proxima Nova", sans-serif;
    color: var(--secondary-color-1);
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    row-gap: 24px;
    text-align: center;
  }
  .mls-detail-page-container .content .top-header .about p br {
    display: none;
  }
  .mls-detail-page-container .content .top-header .about .subhero-banner {
    max-height: 120px;
    object-fit: contain;
  }
  .mls-detail-page-container .content .highlights .highlight {
    gap: 20px;
  }
  .mls-detail-page-container .content .highlights .highlight > div {
    max-width: 300px;
  }
  .mls-detail-page-container .content .market {
    row-gap: 40px;
  }
  .mls-detail-page-container .content .market .image {
    width: 100%;
  }
  .mls-detail-page-container .content .market .details .header br {
    display: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .mls-detail-page-container .content .top-header {
    flex-direction: column-reverse;
    align-items: center;
  }
  .mls-detail-page-container .content .top-header .hero-banner {
    max-height: 350px;
  }
  .mls-detail-page-container .content .top-header .about {
    display: flex;
    width: 100%;
    font-family: "Proxima Nova", sans-serif;
    color: var(--secondary-color-1);
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    row-gap: 24px;
    text-align: center;
  }
  .mls-detail-page-container .content .top-header .about p br {
    display: none;
  }
  .mls-detail-page-container .content .top-header .about .subhero-banner {
    max-height: 120px;
    object-fit: contain;
  }
  .mls-detail-page-container .content .highlights .highlight {
    gap: 20px;
  }
  .mls-detail-page-container .content .highlights .highlight > div {
    max-width: 300px;
  }
  .mls-detail-page-container .content .market {
    row-gap: 40px;
  }
  .mls-detail-page-container .content .market .image {
    width: 100%;
  }
  .mls-detail-page-container .content .market .details .header br {
    display: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .mls-detail-page-container .content .highlights {
    text-align: center;
  }
  .mls-detail-page-container .content .highlights .highlight {
    justify-content: center;
    gap: 20px;
  }
  .mls-detail-page-container .content .highlights .highlight > div {
    max-width: 300px;
  }
  .mls-detail-page-container .content .market {
    row-gap: 40px;
    text-align: center;
  }
  .mls-detail-page-container .content .market .image {
    width: 100%;
  }
  .mls-detail-page-container .content .market .details .header br {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/MLSFooterPage/MLSFooterPage.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;AAFJ;AAGI;EACI,oBAAA;AADR;AAEQ;EACI,aAAA;EACA,SAAA;AAAZ;AACY;EACI,SAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AAChB;AACY;EACI,aAAA;EACA,WAAA;EACA,uCAAA;EACA,+BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,aAAA;AAChB;AAAgB;EACI,iBAAA;EACA,mBAAA;AAEpB;AAAgB;EACI,WAAA;AAEpB;AACoB;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AACxB;AAGoB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AADxB;AAMQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,sBAAA;AAJZ;AAKY;EACI,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAHhB;AAKY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,SAAA;AAHhB;AAKY;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAHhB;AAIgB;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AAFpB;AAGoB;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AADxB;AAGoB;EACI,6BAAA;EACA,mBAAA;AADxB;AAGoB;EACI,+BAAA;EACA,mBAAA;AADxB;AAGoB;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADxB;AAMQ;EACI,aAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAJZ;AAKY;EACI,SAAA;AAHhB;AAKY;EACI,mBAAA;EACA,mBAAA;AAHhB;AAKY;EACI,uCAAA;AAHhB;AAIgB;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAFpB;AAIgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAFpB;AAMQ;EACI,aAAA;EACA,uBAAA;AAJZ;AAMQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,sBAAA;AAJZ;AAKY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,SAAA;AAHhB;AAKY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAHhB;AAKY;EACI,aAAA;EACA,WAAA;EACA,eAAA;AAHhB;AAIgB;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAFpB;AAGoB;EACI,gBAAA;AADxB;AAGoB;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,0CAAA;AADxB;AAEwB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAA5B;AAEwB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAA5B;AAMQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,sBAAA;AAJZ;AAKY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;AAHhB;AAKY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAHhB;AAKY;EACI,aAAA;EACA,sBAAA;AAHhB;AAOI;EACI;IAAO,UAAA;EAJb;EAKM;IAAO,UAAA;EAFb;AACF;;AC7MY;EDoNA;IACI,8BAAA;IACA,mBAAA;EAHd;EAIc;IACI,iBAAA;EAFlB;EAIc;IACI,aAAA;IACA,WAAA;IACA,uCAAA;IACA,+BAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;IACA,aAAA;IACA,kBAAA;EAFlB;EAIsB;IAAK,aAAA;EAD3B;EAGkB;IACI,iBAAA;IACA,mBAAA;EADtB;EAMc;IACI,SAAA;EAJlB;EAKkB;IACI,gBAAA;EAHtB;EAOU;IACI,aAAA;EALd;EAMc;IACI,WAAA;EAJlB;EAQsB;IAAK,aAAA;EAL3B;AACF;AC/PY;ED2NA;IACI,8BAAA;IACA,mBAAA;EAuCd;EAtCc;IACI,iBAAA;EAwClB;EAtCc;IACI,aAAA;IACA,WAAA;IACA,uCAAA;IACA,+BAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;IACA,aAAA;IACA,kBAAA;EAwClB;EAtCsB;IAAK,aAAA;EAyC3B;EAvCkB;IACI,iBAAA;IACA,mBAAA;EAyCtB;EApCc;IACI,SAAA;EAsClB;EArCkB;IACI,gBAAA;EAuCtB;EAnCU;IACI,aAAA;EAqCd;EApCc;IACI,WAAA;EAsClB;EAlCsB;IAAK,aAAA;EAqC3B;AACF;ACzSY;ED8QA;IACI,kBAAA;EA8Bd;EA7Bc;IACI,uBAAA;IACA,SAAA;EA+BlB;EA9BkB;IACI,gBAAA;EAgCtB;EA5BU;IACI,aAAA;IACA,kBAAA;EA8Bd;EA7Bc;IACI,WAAA;EA+BlB;EA3BsB;IAAK,aAAA;EA8B3B;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n\n.mls-detail-page-container {\n    width: 100%;\n    .content {\n        animation: fadeIn 1s;\n        .top-header {\n            display: flex;\n            gap: 40px;\n            .hero-banner {\n                flex: 2;\n                width: 100%;\n                object-fit: contain;\n                max-height: 450px;\n            }\n            .about {\n                display: flex;\n                width: 100%;\n                font-family: 'Proxima Nova', sans-serif;\n                color: var(--secondary-color-1);\n                flex-direction: column;\n                align-items: flex-start;\n                justify-content: flex-start;\n                row-gap: 24px;\n                .subhero-banner {\n                    max-height: 150px;\n                    object-fit: contain;\n                }\n                > div {\n                    width: 100%;\n                }\n                .about {\n                    p {\n                        font-size: 30px;\n                        font-style: normal;\n                        font-weight: 600;\n                        margin: 0;\n                    }\n                }\n                .desc{\n                    span {\n                        font-size: 14px;\n                        font-weight: 400;\n                        line-height: 35px;\n                        text-align: justify;\n                    }\n                }\n            }\n        }\n        .highlights {\n            display: flex;\n            width: 100%;\n            align-items: center;\n            font-family: 'Proxima Nova', sans-serif;\n            flex-direction: column;\n            .top-header {\n                color: var(--primary-color-1);\n                font-size: 16px;\n                font-weight: 700;\n                margin: 0;\n            }\n            .header {\n                font-size: 40px;\n                color: var(--secondary-color-1);\n                font-weight: 700;\n                margin: 0;\n            }\n            .highlight {\n                display: flex;\n                justify-content: space-between;\n                flex-wrap: wrap;\n                column-gap: 20px;\n                > div {\n                    max-width: 320px;\n                    background-color: #F4F5F6;\n                    border-radius: 40px;\n                    padding: 50px;\n                    .number, .title {\n                        font-size: 16px;\n                        font-weight: 700;\n                        margin: 0;\n                    }\n                    .number {\n                        color: var(--primary-color-1);\n                        margin-bottom: 16px;\n                    }\n                    .title {\n                        color: var(--secondary-color-1);\n                        margin-bottom: 18px;\n                    }\n                    .desc {\n                        color: var(--secondary-color-1);\n                        font-size: 14px;\n                        font-weight: 400;\n                        line-height: 30px;\n                    }\n                }\n            }\n        }\n        .market {\n            display: flex;\n            width: 100%;\n            flex-wrap: wrap;\n            column-gap: 100px;\n            > div {\n                flex: 1;\n            }\n            .image {\n                border-radius: 40px;\n                object-fit: contain;\n            }\n            .details {\n                font-family: 'Proxima Nova', sans-serif;\n                .header {\n                    font-size: 40px;\n                    font-weight: 600;\n                    margin: 0;\n                    margin-bottom: 30px;\n                    line-height: 50px;\n                }\n                .body {\n                    font-size: 16px;\n                    font-weight: 400;\n                    line-height: 35px;\n                }\n            }\n        }\n        .app-spec {\n            display: flex;\n            justify-content: center;\n        }\n        .team-container {\n            display: flex;\n            width: 100%;\n            align-items: center;\n            font-family: 'Proxima Nova', sans-serif;\n            flex-direction: column;\n            .header {\n                font-size: 40px;\n                color: var(--secondary-color-1);\n                font-weight: 700;\n                margin: 0;\n            }\n            .subheader {\n                font-size: 16px;\n                color: var(--secondary-color-1);\n                font-weight: 400;\n                text-align: center;\n                line-height: 30px;\n            }\n            .team {\n                display: flex;\n                width: 100%;\n                flex-wrap: wrap;\n                .member {\n                    flex: 1;\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    .member-profile {\n                        max-width: 200px;\n                    }\n                    .member-detail {\n                        height: 70px;\n                        width: 100%;\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n                        text-align: center;\n                        justify-content: center;\n                        background-color: var(--secondary-color-1);\n                        p {\n                            margin: 0;\n                            font-size: 14px;\n                            font-weight: 700;\n                            color: white;\n                            margin-bottom: 6px;\n                        }\n                        span {\n                            font-size: 12px;\n                            font-weight: 400;\n                            color: #F4F5F6;\n                        }\n                    }\n                }\n            }\n        }\n        .why-invest, .get-intouch {\n            display: flex;\n            width: 100%;\n            align-items: center;\n            font-family: 'Proxima Nova', sans-serif;\n            flex-direction: column;\n            .header {\n                font-size: 32px;\n                color: var(--secondary-color-1);\n                font-weight: 700;\n                line-height: 36px;\n            }\n            .subheader {\n                color: #949494;\n                font-size: 20px;\n                font-weight: 400;\n                line-height: 32px;\n                max-width: 600px;\n                text-align: center;\n            }\n            .form {\n                display: flex;\n                animation: fadeIn .5s;\n            }\n        }\n    }\n    @keyframes fadein {\n        from { opacity: 0; }\n        to   { opacity: 1; }\n    }\n}\n@include media(tablet, mobile) {\n    .mls-detail-page-container {\n        .content {\n            .top-header {\n                flex-direction: column-reverse;\n                align-items: center;\n                .hero-banner {\n                    max-height: 350px;\n                }\n                .about {\n                    display: flex;\n                    width: 100%;\n                    font-family: 'Proxima Nova', sans-serif;\n                    color: var(--secondary-color-1);\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: flex-start;\n                    row-gap: 24px;\n                    text-align: center;\n                    p {\n                        br { display: none; }\n                    }\n                    .subhero-banner {\n                        max-height: 120px;\n                        object-fit: contain;\n                    }\n                }\n            }\n            .highlights {\n                .highlight {\n                    gap: 20px;\n                    > div {\n                        max-width: 300px;\n                    }\n                }\n            }\n            .market {\n                row-gap: 40px;\n                .image {\n                    width: 100%;\n                }\n                .details {\n                    .header {\n                        br { display: none; }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .mls-detail-page-container {\n        .content {\n            .highlights {\n                text-align: center;\n                .highlight {\n                    justify-content: center;\n                    gap: 20px;\n                    > div {\n                        max-width: 300px;\n                    }\n                }\n            }\n            .market {\n                row-gap: 40px;\n                text-align: center;\n                .image {\n                    width: 100%;\n                }\n                .details {\n                    .header {\n                        br { display: none; }\n                    }\n                }\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
